<template>
	<section id="hero" class="pt-0">
		<div class="wrapper p-0">
			<carousel :autoplay="true" :perPage="1" :paginationEnabled="false" :autoplayTimeout="20000">
				<slide v-for="(hero,key) in banners" :key="key" class="hero-slide" :style="slideStyle(hero)">

					<div v-if="hero.isVideo" class="video-wrapper">
						<video autoplay muted loop>
							<source :src="hero.src" type="video/mp4">
						</video>
					</div>
				</slide>
			</carousel>
			<div class="overlay">
				<HomeOverlay></HomeOverlay>
			</div>
		</div>
	</section>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';
import HomeOverlay from "./HomeOverlay";

export default {
	name: "HeroSection",
	components: {
		HomeOverlay,
		Carousel,
		Slide
	},
	props: {
		banners: {
			type: Array,
			required: true
		}
	},
	methods: {
		slideStyle(hero) {
			return `${!hero.isVideo ? 'background-image: url(' + hero.src + ');' : ''}`
		},
	}
}
</script>

<style scoped>

#hero {
	border-bottom: 10px solid #0085FF;
}

.hero-slide {
	min-height: 900px;
	/*border: 2px solid #ccc;*/
	background: #0E0E0F;
	color: white;
	text-align: center;
	vertical-align: middle;
	justify-content: center;
	/*border-radius: 9px;*/
}

.hero-slide {
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}


.video-wrapper {
	height: 900px;
	width: auto;
	overflow: hidden;
	position: relative;
	/*border-radius: 9px;*/
}

video {
	min-width: 100%;
	min-height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
}

.wrapper {
	position: relative;
	overflow: hidden;
}

.overlay {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.4);
	/*border-radius: 9px;*/
	/*pointer-events: none;*/
}

.center {
	display: flex;
	text-align: center;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
}

.topleft {
	margin-top: 1%;
	margin-left: 1%;

	width: fit-content;
	padding: 5px 15px;
	border-radius: 9px;
	border: 2px solid white;
	/*background: rgba(0, 0, 0, 0.0);*/
}

.topleft h1 {
	font-size: 1.2em;
}

.topleft h2 {
	font-size: 0.7em;
}

.topleft img {
	max-height: 75px;
}
</style>